





























































































import { Component, Prop } from 'nuxt-property-decorator';
import type { PropType } from 'vue';
import IAElementComponent from './IAElementComponent.vue';
import { IaElementsInterface } from '@/types/contentContract';

@Component({
  name: 'Comparison'
})
export default class Comparison extends IAElementComponent {
  @Prop({ type: Object as PropType<IaElementsInterface>, default: () => [] })
  template!: IaElementsInterface;

  removeAnswers(): void {
    this.answers = [];
    this.isValidated = false;
    this.$refs.inputCompare.forEach((elm) => {
      elm.lazyValue = '';
    });
  }
}
